import axiosInstance from "./axiosInstance";

// Get all posts
export const fetchPosts = async () => {
  const response = await axiosInstance.get("/post");
  return response.data;
};

// Get post by ID
export const getPostByTopicId = async (id) => {
  const response = await axiosInstance.get(`/post/getbytopic?topicId=${id}`);
  return response.data;
};


// Get post by ID
export const getPostById = async (id, userid) => {
  const response = await axiosInstance.get(`/post/get?postId=${id}&userId=${userid}`);
  return response.data;
};
// Create a new post
export const createPost = async (data) => {
  const response = await axiosInstance.post("/post", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// Update a post
export const updatePost = async ({ data }) => {
  const response = await axiosInstance.put(`/post}`, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
  return response.data;
};

// Delete a post
export const deletePost = async (id) => {
  await axiosInstance.delete(`/post/${id}`);
};


// Create a new post
export const votePost = async (data) => {
  const response = await axiosInstance.post("/post/vote", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};


// Create a new post
export const markReadPost = async (data) => {
  debugger;
  const response = await axiosInstance.post("/post/markread", data);
  return response.data;
};

